import { $,_,Backbone,Foundation,Radio,moment,Datepicker } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'
import Notification from '../../utils/Notification'


import ClientDiscountSidebarTpl from '../../templates/pricediscounts/ClientDiscountSidebarTpl.html'

export default InboomaBaseView.extend({

    /* TODO: All that this._updateNotification(); should be called by collection,
     as an "collection:changed" event
     */

    template : ClientDiscountSidebarTpl,
    el : '#inb-c-sidebar',
    templateContext() {
        return {
            _,
            moment
        }
    },

    _filterCountNotification : {},
    _collectionEmptyNotification : {},

    ui : {

    },

    events : {

    },


    initialize () {
        this.render();
    },


});